// React / Redux / Related
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { withRouterV6 } from '../../helpers/withRouterV6.jsx';
import { bindActionCreators } from 'redux';

// Actions
import * as campaignActions from './store/campaignActions';

// Helpers
import get from 'lodash.get';
import { getListWithAdditionalFiltersIfSysAdmin } from '../../helpers/listHelper';
import { hideCondition } from '../../helpers/hideHelper';
import clear from '../../components/clear';
import { Record } from '../../modules/bin/utility';
import { clearRecordMessages } from '../../modules/authentication';
import { withPageTitle } from "../../hocs";
import GridNavigationHelper from '../../helpers/GridNavigationHelper';
import { setRedirectUrl } from '../../modules/session';

// Components
import { Common } from '../../components';
import PreCreateCampaignContainer from './create/precreate';
import RecordResultMessage from '../../components/common/recordResult';
import Spinner from '../../components/common/spinner';
import BasePage from '../../components/common/basePageView';
import Button from '../../components/common/button';
import { Menu } from 'semantic-ui-react';
// Backoffice modal removed - replaced by dedicated screen
import { ExportDownloadProvider } from '../export-history';
import { renderCampaignNameColumn } from './helpers/campaignNameFormatter';

// Constants
import { CONTEXT_MENU_KEYS } from '../../constants/contextMenuEntries';
import { i18nKeys } from './constants';
import { gridKeys } from '../../constants/gridKeys';
import { campaignTypes } from './create/templates';

import {
  ORGANIZATION_ID_FILTER,
  CAMPAIGN_ORGANIZER_ID_FILTER,
  FRANCHISE_ID_FILTER
} from '../../constants/metadataConstants';

// ----------------------------------------------------------------------

/** A page to view all campaigns in a list */
class CampaignList extends Component {
  constructor(props) {
    super(props);
  this.state = {};
  }

  componentDidMount() {
    // Clear any stored return URL when entering this grid
    GridNavigationHelper.clearReturnUrlOnGridEntry();
  }

  clearMessages = () => {
    this.props.actionGrid.clearRecordMessages('recordEdit');
    this.props.actionGrid.clearRecordMessages('recordCreate');
  };

  clearActivateRecordMessage = () => {
    this.props.clearActivateRecord('invite.createAccountRecord');
  };

  isContextMenuFundraisersHide = (item) => {
    return !(item.teams.enabled || item.fundraisers.enabled || item.collections?.enabled);
  };

  isContextMenuDonationsHide = () => {
    return this.props.isEventAdmin;
  };

  isContextMenuSalesAndTicketsHide = (item) => {
    return this.props.isEventAdmin || !get(item, 'ticketing.enabled');
  };

  isContextMerchandiseHide = (item) => {
    return this.props.isEventAdmin || !get(item, 'merchandise.enabled');
  };

  isContextCloneCampaignHide = (item) => {
    return (
      this.props.isCampaignAdmin ||
      this.props.isCampaignOrganizerAdmin ||
      this.props.isEventAdmin ||
      item.type === campaignTypes.event
    );
  };

  showSpinner = () => {
    return (
      this.props.isSessionLoading ||
      Record.isRecordLoading(this.props.createAccountRecord) ||
      Record.isRecordLoading(this.props.impersonatedRecord) ||
      Record.isRecordLoading(this.props.exportFileRecord)
    );
  };

  hideColumnCondition = (item) => {
    return hideCondition(
      this.props.isOrganizationAdmin,
      item,
      'path',
      'organization.name'
    );
  };

  isChooseTabButtonDisabled = () => {
    return (
      Record.isRecordLoading(this.props.list) ||
      Record.isRecordLoading(this.props.list.metadata)
    );
  };

  // Backoffice modal removed

  /**
   * Renders the component
   */
  render() {
    if (this.showSpinner()) {
      return <Spinner />;
    }

    const { Grid } = Common;
    const { Panel, ContextMenu } = Grid.Managed;
    const filterButtons = get(this.props, 'list.filterButtons');

    return (
      <>
        <BasePage>
          <RecordResultMessage
            record={this.props.recordEdit}
            onDismiss={this.clearMessages}
          />
          <RecordResultMessage
            record={this.props.recordCreate}
            onDismiss={this.clearMessages}
          />
          <RecordResultMessage
            record={this.props.createAccountRecord}
            onDismiss={this.clearActivateRecordMessage}
          />
          <div>
            <div className="grid-top-block">
              <h1>
                <Translate value="campaign.title" />
              </h1>
              <Panel>
                <PreCreateCampaignContainer />
              </Panel>
            </div>
            {!this.props.isEventAdmin && (
              <Menu
                className="accounts-tab-buttons-group"
                style={{ margin: '0px', borderRight: '0px' }}
              >
                {Object.keys(filterButtons).map((key) => {
                  const item = filterButtons[key];
                  return (
                    <Menu.Item
                      key={item.key}
                      name={item.key}
                      content={I18n.t(item.I18nKey)}
                      active={item.key === this.props.match.params.tab}
                      disabled={this.isChooseTabButtonDisabled()}
                      onClick={() => {
                        this.props.history.push(`/campaigns/${item.key}`);
                      }}
                    />
                  );
                })}
              </Menu>
            )}
            <Grid.Managed
              listKey={this.props.listKey}
              list={getListWithAdditionalFiltersIfSysAdmin(
                this.props.list,
                this.props.isSystemAdmin,
                [
                  ORGANIZATION_ID_FILTER,
                  CAMPAIGN_ORGANIZER_ID_FILTER,
                  FRANCHISE_ID_FILTER
                ]
              )}
              actions={this.props.actionGrid}
              toggleColumns
              search
              hideColumn={this.hideColumnCondition}
              activeTabFilter={this.props.match.params.tab}
              filtersButton
              columnRender={renderCampaignNameColumn(this.props.isSystemAdmin)}
            >
              {this.props.isExportDataAllowed && (
                <Panel name="right">
                  <ExportDownloadProvider entity="page/Campaign">
                    {({ open }) => (
                      <Button onClick={() => open(this.props.list.request)}>
                        <Translate value="campaign.export" />
                      </Button>
                    )}
                  </ExportDownloadProvider>
                </Panel>
              )}
              <ContextMenu>
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_DASHBOARD.key}
                  label={I18n.t('campaign.list.context.dashboard-campaign')}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_PERFORMANCE
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.EDIT_CAMPAIGN.key}
                  label={I18n.t('campaign.list.context.edit-campaign')}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.EDIT_CAMPAIGN
                  }
                  onClick={GridNavigationHelper.createEditClickHandler(
                    this.props.setRedirectUrl,
                    this.props.location
                  )}
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_PUBLIC_PAGE.key}
                  label={I18n.t('campaign.list.context.view-public-page')}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_PUBLIC_PAGE
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_SALES.key}
                  label={I18n.t('campaign.list.context.view-sales')}
                  isHiden={this.isContextMenuSalesAndTicketsHide}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_SALES
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_TICKETS.key}
                  label={I18n.t('campaign.list.context.view-tickets')}
                  isHiden={this.isContextMenuSalesAndTicketsHide}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_TICKETS
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_MERCHANDISE.key}
                  label={I18n.t('campaign.list.context.view-merchandise')}
                  isHiden={this.isContextMerchandiseHide}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_MERCHANDISE
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_DONATIONS.key}
                  label={I18n.t('campaign.list.context.view-donations')}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_DONATIONS
                  }
                  isHiden={this.isContextMenuDonationsHide}
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_FUNDRAISERS.key}
                  label={I18n.t('campaign.list.context.view-fundraisers')}
                  isHiden={this.isContextMenuFundraisersHide}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.VIEW_FUNDRAISERS
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.CAMPAIGN_MENU.CLONE_CAMPAIGN.key}
                  label={I18n.t('campaign.list.context.clone-campaign')}
                  isHiden={this.isContextCloneCampaignHide}
                  contextMenuOptions={
                    CONTEXT_MENU_KEYS.CAMPAIGN_MENU.CLONE_CAMPAIGN
                  }
                />
                <ContextMenu.Item
                  key={CONTEXT_MENU_KEYS.EVENTS.BACK_OFFICE.key}
                  label={I18n.t(i18nKeys.BACK_OFFICE)}
                  onClick={(_id, item) => this.props.history.push(`/campaigns/${item.id}/backoffice`)}
                  isHiden={() => !this.props.isSystemAdmin}
                  systemOnly
                />
              </ContextMenu>
            </Grid.Managed>
          </div>
        </BasePage>
  {/* Backoffice modal removed */}
      </>
    );
  }
}

/** Maps the state to properties */
const mapState = ({ campaign, authentication, account, session, ...rest }) => {
  const { templates, recordEdit, recordCreate } = campaign;

  const isOrganizationAdmin = get(session, 'isOrganizationAdmin');
  const isEventAdmin = get(session, 'isEventAdmin');
  const isCampaignAdmin = get(session, 'isCampaignAdmin');
  const isCampaignOrganizerAdmin = get(session, 'isCampaignOrganizerAdmin');

  // A reference to the list in state
  const stateGrid = Common.Grid.Managed.mapGridState(
    campaign,
    gridKeys.CAMPAIGNS
  );

  return {
    templates,
    recordEdit,
    recordCreate,
    listKey: stateGrid.key,
    list: stateGrid.list,
    createAccountRecord: authentication.invite.createAccountRecord,
    impersonatedRecord: account.impersonatedRecord,
    exportFileRecord: campaign.exportFileRecord,
    isSystemAdmin: get(session, 'isSystemAdmin'),
    isOrganizationAdmin,
    isCampaignAdmin,
    isEventAdmin,
    isCampaignOrganizerAdmin,
    isSessionLoading: get(session, 'processing'),
    isExportDataAllowed: get(session, 'permissions.exportData') === 'allow'
  };
};

/** Maps the actions to properties */
const mapDispatch = (dispatch) => {
  const actionGrid = Common.Grid.Managed.bindGridActions(
    dispatch,
    campaignActions
  );
  const clearActivateRecord = bindActionCreators(clearRecordMessages, dispatch);
  const setRedirectUrlAction = bindActionCreators(setRedirectUrl, dispatch);
  return {
    actionGrid,
    clearActivateRecord,
    setRedirectUrl: setRedirectUrlAction
  };
};

const titleResolver = (props) => {
  const tab = get(props, 'match.params.tab', 'all');
  let capitalizedTab = tab.charAt(0).toUpperCase() + tab.slice(1);
  return I18n.t('page-titles.campaigns.list', { tab: capitalizedTab });
};

/** Connects component to Redux store */
const CampaignPageContainer = clear(
  withRouterV6(connect(mapState, mapDispatch)(withPageTitle(titleResolver)(CampaignList)))
);
export default CampaignPageContainer;
